import React, { useMemo } from "react";
import GenericCreate from "../GenericCreate";
import { buildTeacherCourseConfig } from "./Config";

const DEBUG = (window && typeof window !== "undefined") ? (window.__APP_DEBUG__ ?? true) : true;

export default function CreateTeacherCourseForm({
  userRole,
  onTeacherChange,
  mode = "create",
  editRecord = null,
  selectedTeacherUser = "",
  onAfterSubmit,
  formKey,
  initialTeacherOption = null,
  feeOnly = false,
}) {
  const cfg = useMemo(() => {
    const c = buildTeacherCourseConfig({
      mode,
      record: editRecord,
      selectedTeacherUser,
      onAfterSubmit,
      feeOnly,
    });
    // Inject initial option to teacher field if provided
    if (initialTeacherOption && c?.fields?.teacher) {
      c.fields.teacher.initialOption = initialTeacherOption;
    }
    return c;
  }, [mode, editRecord, selectedTeacherUser, onAfterSubmit, initialTeacherOption, feeOnly]);

  return (
    <>
      <GenericCreate
        key={formKey}
        dense
        formTitle={null}
        initialState={cfg.initialState}
        submitUrl={cfg.submitUrl}
        instanceConfig={cfg}
        submitMethod={cfg.submitMethod}
        userRole={userRole}
        onFieldChange={(field, value) => {
        // DEBUG && console.info("✍️ onFieldChange:", field, value);
          if (field === "teacher") onTeacherChange?.(value || "");
        }}
        // Show confirmation dialog only in edit mode
        showConfirmationDialog={mode === "edit"}
        confirmationTitle="تأیید ویرایش"
        confirmationMessage="آیا از ویرایش این دوره اطمینان دارید؟"
      />
    </>
  );
}
